import { Breadcrumbs } from "baseui/breadcrumbs";
import { StyledLink } from "baseui/link";
import { useGetHierarchyByIdQuery } from '../../services/objects'
import { IAutomationObject } from "../../automationObjects";
import { GetObjectUrl } from "../../utils/navigationService";
import { useStyletron } from "baseui";
import { Link } from "react-router-dom";
import { Block } from "baseui/block";
import { VscChevronRight } from "react-icons/vsc";

export interface HierarchyProps {
    objectId: string,
    resourceGroupId: string,
    current: string,
    currentDescription: string,
    showDescription: boolean,
    currentAsLink: boolean,
    className?: any,
    skip?: number // skip number of top levels
}

const Hierarchy = ({ objectId, resourceGroupId, current, showDescription, currentDescription, currentAsLink, className, skip }: HierarchyProps) => {
    const [css, theme] = useStyletron();
    const { data, isLoading, isSuccess, error } = useGetHierarchyByIdQuery({ objectId: objectId, resourceGroupId: resourceGroupId });

    const items = skip ? data?.slice(skip) : data;
    return (
        <Block justifyContent={'flex-start'} alignContent='flex-start'
            marginTop={theme.sizing.scale200}
            marginBottom={theme.sizing.scale200}
            flexWrap className={className} display='flex'
            flexDirection='row'
            gridGap={theme.sizing.scale100}
            alignItems='center'>
            {items?.map((item: IAutomationObject, index: number) => {
                return (

                    <div key={item.id} className={css({ display: 'flex', gap: theme.sizing.scale200, alignItems: 'center' })}>
                        <Link to={GetObjectUrl(item.resourceGroupId, item.id)} className={css({ textDecoration: 'none' })}>
                            <StyledLink>{showDescription ? (item.description ? item.description : item.name) : item.name}</StyledLink>
                        </Link>
                        {(items?.length > index + 1 || currentAsLink) && <VscChevronRight color={theme.colors.primary}></VscChevronRight>}
                    </div>
                )
            })}
            {currentAsLink &&
                <Link key={9999999} to={GetObjectUrl(resourceGroupId, objectId)} className={css({ textDecoration: 'none' })}>
                    <StyledLink>{showDescription ? (currentDescription ? currentDescription : current) : current}</StyledLink>
                </Link>
            }

        </Block>
    )
}

export default Hierarchy;

